import { useFinalBalanceContext } from "../FinalBalanceContainer";
import { TaxCalculations } from "../../../model/tax_calculations";
import BalanceRefund from "./BalanceRefund";
import BalanceDue from "./BalanceDue";
import NoBalance from "./NoBalance";

// Turns out most of this is conditional context copy, and the extra components are unnecessary
function AppropriateBalanceOption({ taxCalculations, taxBalance }: { taxCalculations: TaxCalculations, taxBalance: number }) {
  if (taxBalance === 0) {
    return <NoBalance
      taxBalance={taxBalance}
      taxBreakdown={taxCalculations}
    />
  } else if (taxBalance > 0) {
    return <BalanceDue
      finalBalance={taxBalance}
      taxBreakdown={taxCalculations}
    />
  } else if (taxBalance < 0) {
    return <BalanceRefund
      finalBalance={taxBalance}
      taxBreakdown={taxCalculations}
      />
  } else {
    // TODO: add redirect to Sorry page or similar
    return <p>Sorry!</p>
  }
}

const BalanceOptions = () => {
  const { calculations } = useFinalBalanceContext();
  const finalBalance = calculations.final_balance;

  return (
    <AppropriateBalanceOption
      taxBalance={finalBalance}
      taxCalculations={calculations}
      />
  );
}

export default BalanceOptions;
